<template>
  <b-container class="p-0" fluid>
    <div v-if="show" :class="{ 'not-allowed-backdrop': true, mobile: isMobile }">
      <div :class="{ 'not-allowed-modal': true, mobile: isMobile }">
        <div class="not-allowed-message">{{ msg }}</div>
        <div v-if="isMobile" class="not-allowed-close">
          <cancel label="閉じる" v-on:cancel="doAppClose" />
        </div>
      </div>
    </div>
  </b-container>
</template>

<style lang="scss" scoped>
.not-allowed-backdrop {
  display: flex;
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  &.mobile {
    top: 0;
    z-index: 1021; // Navbar(z-index=1020)より上に表示
  }
}

.not-allowed-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 1);
  margin: auto;
  box-sizing: border-box;
  min-height: 100px;
  width: 500px;
  max-width: 80%;
  height: 100px;
  border-radius: 8px;
  flex-direction: column;

  &.mobile {
    width: 80vw;
    max-width: 360px;
  }
}

.not-allowed-message {
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
}

.not-allowed-close {
  padding: 0px 16px 16px 16px;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import Cancel from "./button/Cancel.vue";
import { useLegacyRootEvent } from "../composables/useLegacyRootEvent";

export default defineComponent({
  name: "not-allowed-modal",
  components: { Cancel },
  props: {
    msg: { type: String, default: "", required: true },
    show: { type: Boolean, default: false },
    icon: { type: String, default: "/img/icon/1152921507291203198.png" },
    isMobile: { type: Boolean, default: false },
  },
  setup() {
    const rootEvent = useLegacyRootEvent();

    // Applicationを閉じる
    const doAppClose = (): void => {
      rootEvent.emit("on-app-close");
    };

    return { doAppClose };
  },
});
</script>
